import { render } from "./Index.vue?vue&type=template&id=7c83574e"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=7c83574e&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Vendors/Establishments/Facilities/New/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c83574e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c83574e', __exports__)) {
    api.reload('7c83574e', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=7c83574e", () => {
    api.rerender('7c83574e', render)
  })

}


export default __exports__